import React from "react";
import { SidebarIcons } from "../../StandardContentSidebar/SidebarIcons";

const adminhomemenu = [
  {
    uri: `user-admin-dashboard`,
    label: "Home",
    type: "nav-item",
    icon: SidebarIcons.UserAdminHomeIcon,
    color: "#4B4B4B",
  }
];

export default adminhomemenu;
